<!-- DESKTOP VERSION -->
<ion-card class="application-card">
  <div class="img-container">
    <img [src]="application?.program?.image | img: application?.state:'md'" class="fillheight" />
  </div>
  <ion-card-header class="card-header ion-text-center">
    <ion-label class="bold-text" class="steps-text">Next action: {{futureStatus}}.</ion-label>
  </ion-card-header>
  <ion-card-content>
    <div class="vertical-align">
      <ion-card-title class="bold-text">{{application?.name | truncate: [65, '...']}}</ion-card-title>
      <p class="card-subtitle">
        <fa-icon [icon]="faMapMarkerAlt" class="icon-padding"></fa-icon> {{application?.city | truncate: [10, '...']}}, {{application?.state | truncate: [10, '...']}} -
        {{application?.type}}
      </p>
      <p class="application-dates"><fa-icon [icon]="faCalendar" class="icon-padding"></fa-icon>{{application?.startdate | date: 'longDate' : 'UTC' }} -
        {{application?.enddate | date: 'longDate' : 'UTC'}}</p>
      <div class="detail-arrow">
        <fa-icon [icon]="faChevronRight" class="icon-padding"></fa-icon>
      </div>
    </div>
  </ion-card-content>
</ion-card>
<!-- MOBILE VERSION -->
<ion-item lines='none' class="application-mobile">
  <div class="img-container">
    <ion-thumbnail>
      <img [src]="application?.program?.image | img: application?.state:'sm'" />
    </ion-thumbnail>
  </div>
  <div class="application-text-container">
    <ion-card-title>{{application?.name | truncate:[50, '...'] }}</ion-card-title>
    <div class="card-subtitle">
      <fa-icon [icon]="faMapMarkerAlt" class="icon-padding"></fa-icon>{{application?.city}}, {{application?.state}}
    </div>
    <div class="card-subtitle">
      <fa-icon [icon]="faCalendar" class="icon-padding"></fa-icon> {{application?.startdate | date: 'longDate' : 'UTC' }} -
      {{application?.enddate | date: 'longDate' : 'UTC'}}
    </div>
    <div class="card-subtitle">{{application?.type}}</div>
    <div class="next-actions-mobile">
      <span class="app-status-text">Next action: {{futureStatus}}.</span>
    </div>
  </div>

  <div class="detail-arrow" slot="end">
    <fa-icon [icon]="faChevronRight" style="color: var(--ion-color-neon-teal)"></fa-icon>
  </div>
</ion-item>